import React, { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";

import "./App.css";

import PrintPage from "./components/PrintPage";
import WebPage from "./components/WebPage";

function App() {
  const [activeSection, setActiveSection] = useState("about");
  const handleScroll = () => {
    const sections = document.querySelectorAll("section");
    let currentSection = "";

    sections.forEach((section) => {
      const rect = section.getBoundingClientRect();

      const style = window.getComputedStyle(section);
      const marginTop = parseInt(style.marginTop, 10);
      const marginBottom = parseInt(style.marginBottom, 10);

      const effectiveTop = rect.top - marginTop;
      const effectiveBottom = rect.bottom + marginBottom;

      if (effectiveTop <= 0 && effectiveBottom > 0) {
        currentSection = section.id;
      }
    });

    if (currentSection) {
      setActiveSection(currentSection);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <Routes>
      <Route path="/print" element={
        <div className="app">
          <PrintPage />
        </div>
      }
      />
      <Route path="/*" element={
        <div className="app">
          <WebPage activeSection={activeSection} />
        </div>
      }
      />
    </Routes>
  );
}

export default App;
